<template>
  <a-layout-sider
    :class="'default-top-sider'"
    :collapsed="siderCollapsed"
    :breakpoint="sider.breakpoint"
    :width="sider.width"
    :collapsedWidth="sider.collapsedWidth"
    :trigger="null"
    @breakpoint="onBreakPoint"
    collapsible
  >
    <div :class="'default-top-brand'">
      <router-link :class="'default-top-brand__logo'" to="/" title="home">
        <i :class="'fas fa-globe-americas'"></i>
      </router-link>
      <h1 :class="'default-top-brand__title'">{{ title }}</h1>
    </div>
  </a-layout-sider>
</template>

<script>
export default {
  props: ['title', 'sider', 'siderCollapsed'],
  data() {
    return {};
  },
  methods: {
    onBreakPoint(broken) {
      this.$emit('on-break-point', broken);
    },
  },
};
</script>

<style lang="scss" scoped>
.default {
  &-top-sider {
    height: $header-height;
    margin-left: -16px;

    background: transparent;
  }

  &-top-brand {
    overflow: hidden;

    transition: width 0.2s;

    flex-wrap: wrap;

    &,
    &__logo,
    &__title {
      display: flex;
      height: $header-height;

      justify-content: center;
    }

    &__logo,
    &__title {
      color: #fff;

      align-items: center;
    }

    &__logo {
      font-size: 36px;

      &:hover,
      &:active {
        text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.4);
      }
    }

    &__title {
      padding: 0 18px;
      margin: 0;

      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      font-size: 22px;
      font-weight: 600;
      line-height: 0;
    }
  }
}
</style>
